/**
 * Minimal external store (`subscribe` / `getSnapshot`), compatible with React's
 * `useSyncExternalStore` and usable from any framework. Snapshots are immutable;
 * `set` replaces the snapshot only when a field actually changed.
 */
export class Store {
    value;
    subs = new Set();
    constructor(initial) {
        this.value = initial;
    }
    getSnapshot = () => this.value;
    subscribe = (cb) => {
        this.subs.add(cb);
        return () => {
            this.subs.delete(cb);
        };
    };
    /** Shallow-merge `patch`; notifies only when something changed. */
    set(patch) {
        let changed = false;
        for (const k of Object.keys(patch)) {
            if (!Object.is(this.value[k], patch[k])) {
                changed = true;
                break;
            }
        }
        if (!changed)
            return;
        this.value = { ...this.value, ...patch };
        for (const cb of [...this.subs])
            cb();
    }
}
//# sourceMappingURL=store.js.map